import { Link } from "react-router-dom";

export default function Logo() {
    return (
        <Link
            to="/"
            data-testid="logo-link"
            className="flex items-center"
            aria-label="sthaan — home"
        >
            <img
                src="/logo.png"
                alt="sthaan"
                className="h-6 w-auto sm:h-7"
            />
        </Link>
    );
}
